import { render, staticRenderFns } from "./FullscreenWait.vue?vue&type=template&id=3dc8faed&scoped=true&"
import script from "./FullscreenWait.vue?vue&type=script&lang=js&"
export * from "./FullscreenWait.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenWait.vue?vue&type=style&index=0&id=3dc8faed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc8faed",
  null
  
)

export default component.exports